(() => {
  if (window.dervoAuditLoaded) return;
  window.dervoAuditLoaded = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  function init(root = document) {
    root.querySelectorAll('[data-dervo-search]').forEach(form => {
      if (states.has(form)) return;
      const controller = new AbortController(), signal = controller.signal;
      const input = form.querySelector('[name=q]'), panel = form.querySelector('.dh-predictive'), status = form.querySelector('[data-search-status]');
      let timer, request, version = 0;
      const close = () => { panel.hidden = true; input.setAttribute('aria-expanded','false'); };
      const cancel = () => { clearTimeout(timer); request?.abort(); version++; close(); };
      const open = () => { panel.hidden = false; input.setAttribute('aria-expanded','true'); };
      const listen = (el, type, fn) => el.addEventListener(type, fn, {signal});
      listen(input, 'input', () => {
        cancel(); const q = input.value.trim(); if (q.length < 2) return;
        const current = version;
        timer = setTimeout(async () => {
          request = new AbortController();
          try {
            const url = new URL((window.Shopify?.routes?.root || '/')+'search/suggest.json', location.origin);
            url.searchParams.set('q',q);url.searchParams.set('resources[type]','product,collection,page');url.searchParams.set('resources[limit]','6');
            const response = await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('suggestions');
            const data = await response.json(); if(current!==version || !form.contains(document.activeElement))return;
            const results = data.resources?.results || {}, rows = [...(results.products||[]),...(results.collections||[]),...(results.pages||[])];
            panel.replaceChildren();
            for(const row of rows) {
              const target = new URL(row.url,location.origin); if(target.origin!==location.origin)continue;
              const link=document.createElement('a');link.href=target.href;
              const src=row.featured_image?.url || row.image;
              if(typeof src==='string' && /^(https?:\/\/|\/)/.test(src)){const image=document.createElement('img');image.src=src;image.alt='';image.width=48;image.height=48;link.append(image);}
              const title=document.createElement('span');title.textContent=row.title;link.append(title);
              if(row.price!=null && Number.isFinite(Number(row.price))){const price=document.createElement('small');price.textContent=new Intl.NumberFormat(document.documentElement.lang||'nl',{style:'currency',currency:form.dataset.currency||'EUR'}).format(Number(row.price));link.append(price);}
              panel.append(link);
            }
            if(!rows.length){const empty=document.createElement('p');empty.textContent=form.dataset.empty;panel.append(empty);}
            const all=document.createElement('a'), allUrl=new URL(form.action,location.origin);allUrl.searchParams.set('q',q);all.href=allUrl.href;all.className='dh-search-all';all.textContent=form.dataset.all+' →';panel.append(all);
            status.textContent=rows.length ? form.dataset.found.replace('[aantal]',String(rows.length)) : form.dataset.empty;open();
          }catch(error){if(error.name!=='AbortError' && current===version)close();}
        },180);
      });
      listen(form,'keydown',event=>{
        const links=[...panel.querySelectorAll('a')];
        if(event.key==='Escape'){event.preventDefault();cancel();input.focus();return;}
        if(!panel.hidden && ['ArrowDown','ArrowUp'].includes(event.key)){event.preventDefault();const i=links.indexOf(document.activeElement);links[i<0?(event.key==='ArrowDown'?0:links.length-1):(i+(event.key==='ArrowDown'?1:-1)+links.length)%links.length]?.focus();}
      });
      listen(form,'focusout',e=>{if(!form.contains(e.relatedTarget))cancel();});
      listen(form,'submit',cancel);
      states.set(form,()=>{cancel();controller.abort();});
    });
    root.querySelectorAll('[data-ds-collapse]').forEach(host=>{
      if(states.has(host))return;
      const button=host.querySelector('[data-ds-expand]'),content=host.querySelector('.dp-description,.ds-richtext');if(!button||!content)return;
      const controller=new AbortController();let frame, width;
      const check=()=>{if(!host.isConnected||button.getAttribute('aria-expanded')==='true')return;host.classList.remove('no-collapse');const needed=content.scrollHeight>content.clientHeight+2;button.hidden=!needed;host.classList.toggle('no-collapse',!needed);};
      const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(check);};
      const observer=new ResizeObserver(entries=>{const next=entries[0].contentRect.width;if(next!==width){width=next;schedule();}});observer.observe(host);
      button.addEventListener('click',schedule,{signal:controller.signal});
      schedule();document.fonts?.ready.then(schedule);
      states.set(host,()=>{controller.abort();observer.disconnect();cancelAnimationFrame(frame);});
    });
    root.querySelectorAll('.ds-filter-values').forEach(el=>{if(el.querySelectorAll('.ds-filter-value').length>10)el.classList.add('is-limited');});
  }
  document.addEventListener('click', event => {
    const category=event.target.closest('[data-category-step]');
    if(category){const track=category.closest('.ds-categories').querySelector('.ds-category-track');track.scrollBy({left:Number(category.dataset.categoryStep)*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});}
    const more=event.target.closest('[data-filter-more]');
    if(more){const open=more.getAttribute('aria-expanded')!=='true';more.setAttribute('aria-expanded',String(open));more.closest('.ds-filter').querySelector('[data-filter-values]').classList.toggle('is-limited',!open);more.textContent=open?more.dataset.close:more.dataset.open;}
    const summary=event.target.closest('.ds-filter-toggle');
    if(summary && matchMedia('(max-width:749px)').matches){
      event.preventDefault();const shell=summary.closest('.ds-filter-shell'),form=shell.querySelector('form');if(!form)return;
      const placeholder=document.createComment('filters');form.before(placeholder);
      const dialog=document.createElement('dialog');dialog.className='dh ds ds-filter-dialog';dialog.setAttribute('aria-label',summary.textContent.trim());
      const heading=document.createElement('h2');heading.textContent=summary.textContent.replace('⌄','').trim();
      const close=document.createElement('button');close.type='button';close.className='dh-dialog-close';close.textContent='×';close.setAttribute('aria-label',shell.dataset.closeLabel);close.addEventListener('click',()=>dialog.close());
      dialog.append(close,heading,form);document.body.append(dialog);
      const mq=matchMedia('(min-width:750px)'), resized=()=>dialog.close();mq.addEventListener('change',resized,{once:true});
      dialog.addEventListener('close',()=>{placeholder.replaceWith(form);dialog.remove();mq.removeEventListener('change',resized);summary.focus();},{once:true});dialog.showModal();
    }
  });
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>{for(const [el,dispose]of states)if(e.target.contains(el)){dispose();states.delete(el);}});
})();

/* Dervo: derive swatch fills from their own variant photo; no layout changes. */
(() => {
  if (window.dervoPhotoTones) return;
  window.dervoPhotoTones = true;
  const selector = '.dp-color-dot[data-dervo-photo]';
  const jobs = [], results = new Map();
  let active = 0;
  const version = 'dervo-tone-v2:';
  function hsv(r,g,b) {
    const hi=Math.max(r,g,b),lo=Math.min(r,g,b),d=hi-lo;
    let h=0;
    if(d) h=hi===r?((g-b)/d+6)%6:hi===g?(b-r)/d+2:(r-g)/d+4;
    return [h*60,hi?d/hi:0,(hi+lo)/510];
  }
  function family(name) {
    if (/antraciet|anthracite/.test(name)) return 'anthracite';
    if (/zwart|black/.test(name)) return 'black';
    if (/donkergrijs|dark grey|dark gray/.test(name)) return 'darkgray';
    if (/lichtgrijs|light grey|light gray/.test(name)) return 'lightgray';
    if (/grijs|grey|gray|zilver|chroom|roestvrij|staal/.test(name)) return 'gray';
    if (/crème|creme|cream|ivoor/.test(name)) return 'cream';
    if (/wit|white/.test(name)) return 'white';
    if (/taupe/.test(name)) return 'taupe';
    if (/beige|zand|sand|naturel|eiken|bamboe|licht antiek/.test(name)) return 'beige';
    if (/walnoot|bruin|brown|cognac|teak|donker antiek/.test(name)) return 'brown';
    if (/groen|green|hunter|olijf/.test(name)) return 'green';
    if (/blauw|blue|petrol|indigo/.test(name)) return 'blue';
    if (/roze|pink/.test(name)) return 'pink';
    if (/paars|purple|lila/.test(name)) return 'purple';
    if (/oranje|orange|terracotta|roest|rust/.test(name)) return 'orange';
    if (/rood|red|bordeaux/.test(name)) return 'red';
    if (/geel|yellow|oker|goud|gold/.test(name)) return 'yellow';
    return 'other';
  }
  function accepts(f,h,s,l) {
    switch(f) {
      case 'black': return s<.32 && l>.035 && l<.29;
      case 'anthracite': return s<.28 && l>.13 && l<.40;
      case 'darkgray': return s<.25 && l>.19 && l<.48;
      case 'gray': return s<.22 && l>.28 && l<.79;
      case 'lightgray': return s<.20 && l>.55 && l<.91;
      case 'white': return s<.18 && l>.77 && l<.975;
      case 'cream': return h>20 && h<65 && s>.025 && s<.32 && l>.63;
      case 'taupe': return h>12 && h<65 && s>.04 && s<.33 && l>.28 && l<.72;
      case 'beige': return h>15 && h<67 && s>.06 && s<.59 && l>.46 && l<.91;
      case 'brown': return h>5 && h<58 && s>.14 && l>.14 && l<.62;
      case 'green': return h>65 && h<178 && s>.10 && l>.12 && l<.85;
      case 'blue': return h>175 && h<265 && s>.12 && l>.10 && l<.88;
      case 'pink': return (h>310 || h<18) && s>.08 && l>.44;
      case 'purple': return h>260 && h<325 && s>.10 && l>.18;
      case 'orange': return h>5 && h<40 && s>.28 && l>.23;
      case 'red': return (h<16 || h>340) && s>.25 && l>.14;
      case 'yellow': return h>34 && h<70 && s>.25 && l>.29;
      default: return l>.12 && l<.90;
    }
  }
  function estimate(pixels,w,h,name,frame) {
    const f=family(name), bins=new Map();
    // Sample the upper/central product body, avoiding floor shadows and image edges.
    for(let y=Math.floor(h*(frame ? 0.50 : 0.12));y<h*(frame ? 0.91 : 0.74);y++) for(let x=Math.floor(w*.13);x<w*.87;x++) {
      const i=(y*w+x)*4,r=pixels[i],g=pixels[i+1],b=pixels[i+2];
      if(pixels[i+3]<240 || Math.min(r,g,b)>247) continue;
      const [hue,s,l]=hsv(r,g,b);
      if(!accepts(f,hue,s,l)) continue;
      const key=(r>>4)+','+(g>>4)+','+(b>>4);
      let bin=bins.get(key);
      if(!bin) bins.set(key,bin={n:0,r:0,g:0,b:0});
      const weight=1-Math.abs(x/w-.5)*.6;
      bin.n+=weight; bin.r+=r*weight; bin.g+=g*weight; bin.b+=b*weight;
    }
    const ranked=[...bins.values()].sort((a,b)=>b.n-a.n);
    if(!ranked.length || ranked.reduce((n,b)=>n+b.n,0)<45) return null;
    const peak=ranked[0], center=[peak.r/peak.n,peak.g/peak.n,peak.b/peak.n];
    let n=0,r=0,g=0,b=0;
    for(const bin of ranked) {
      const c=[bin.r/bin.n,bin.g/bin.n,bin.b/bin.n];
      if(Math.hypot(...c.map((v,i)=>v-center[i]))>40) continue;
      n+=bin.n;r+=bin.r;g+=bin.g;b+=bin.b;
    }
    return '#'+[r/n,g/n,b/n].map(v=>Math.round(v).toString(16).padStart(2,'0')).join('');
  }
  async function photoColor(url,name,frame) {
    const key=version+url+'|'+name+'|'+frame;
    if(results.has(key)) return results.get(key);
    const task=(async()=>{
      try { const cached=sessionStorage.getItem(key); if(cached) return cached; } catch(_) {}
      const image=new Image(); image.crossOrigin='anonymous'; image.decoding='async';
      const loaded=new Promise((resolve,reject)=>{
        const timer=setTimeout(()=>{image.onload=null;image.onerror=null;reject(new Error('photo timeout'));},12000);
        image.onload=()=>{clearTimeout(timer);resolve();};
        image.onerror=()=>{clearTimeout(timer);reject(new Error('photo unavailable'));};
      });
      image.src=url;
      await loaded;
      const canvas=document.createElement('canvas');canvas.width=112;canvas.height=112;
      const ctx=canvas.getContext('2d',{willReadFrequently:true});
      ctx.drawImage(image,0,0,112,112);
      const pixels=ctx.getImageData(0,0,112,112).data;
      const names=[...new Set(name.split(/[\/＋+]/).map(n=>n.trim()).filter(Boolean))].slice(0,2);
      const tones=names.map(n=>estimate(pixels,112,112,n,frame));
      if(!tones.length || tones.some(t=>!t)) return null;
      const color=tones.length===2 && tones[0]!==tones[1]?`linear-gradient(135deg,${tones[0]} 0%,${tones[0]} 50%,${tones[1]} 50%,${tones[1]} 100%)`:tones[0];
      try {sessionStorage.setItem(key,color);} catch(_) {}
      return color;
    })().catch(()=>null);
    results.set(key,task);return task;
  }
  function pump() {
    while(active<3 && jobs.length) {
      const el=jobs.shift();active++;
      photoColor(el.dataset.dervoPhoto,el.dataset.dervoTone||'',el.dataset.dervoFrame==='true').then(color=>{
        if(color) {el.style.background=color;el.dataset.dervoSampled='photo';}
        else el.dataset.dervoSampled='fallback';
      }).finally(()=>{active--;pump();});
    }
  }
  const observer='IntersectionObserver' in window?new IntersectionObserver(entries=>{
    for(const entry of entries) if(entry.isIntersecting) {
      observer.unobserve(entry.target);jobs.push(entry.target);
    }
    pump();
  },{rootMargin:'220px'}):null;
  function scan(root=document) {
    for(const el of root.querySelectorAll(selector)) {
      if(el.dataset.dervoQueued || !el.dataset.dervoPhoto) continue;
      el.dataset.dervoQueued='true';
      if(observer) observer.observe(el);else jobs.push(el);
    }
    pump();
  }
  let queued=false;
  const changes=new MutationObserver(records=>{
    if(queued || !records.some(r=>r.addedNodes.length)) return;
    queued=true;requestAnimationFrame(()=>{queued=false;scan();});
  });
  function start(){scan();changes.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
